module.exports = __webpack_public_path__ + "img/car-c.9368492a.png";